import { daysBetween } from '@moonpig/web-shared-utils'
import { LocaleTextHook } from '@moonpig/web-core-locale-text'
import { PromptReminder } from './types'
import { REMINDER_PROMPT_TEXT } from './ReminderPrompt.locale'

export const PROMPT_CLOSING_TIME_MS = 120

export const buildReminderBannerTitle = ({
  reminderName,
  title,
  localiseText,
}: {
  reminderName: string
  title: string
  localiseText: LocaleTextHook<typeof REMINDER_PROMPT_TEXT>
}): string => {
  return `${title} ${localiseText('find.reminder_prompt_for')} ${reminderName}`
}

export const buildReminderSubtitleDays = ({
  reminder,
  localiseText,
}: {
  reminder: PromptReminder
  localiseText: LocaleTextHook<typeof REMINDER_PROMPT_TEXT>
}) => {
  const daysUntil = daysBetween(new Date(), new Date(reminder.nextDate))

  return `${daysUntil} ${
    daysUntil !== 1
      ? localiseText('find.reminder_prompt_days')
      : localiseText('find.reminder_prompt_day')
  }`
}
